import script from "./ToggleGroup.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string%20%7C%20number"
export * from "./ToggleGroup.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string%20%7C%20number"

const __exports__ = script;

export default __exports__